<template>
    <div>
        <b-modal id="modal-delete" title="Delete">
            <p>Are you sure?</p>
            <ul>
                <li>Deleting a category will remove all references to it from posts.</li>
                <li>Posts that are in this category will not be affected.</li>
            </ul>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button variant="outline" @click="cancel()">Cancel</b-button>
                <b-button variant="danger" @click="deleteCategory(deleteId)">Delete</b-button>
            </template>
        </b-modal>


        <div v-if="loading">Loading...</div>
        <div v-else>
            <div class="list-group">
                <template v-for="category in categories">
                    <div class="list-group-item bg-white">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="d-inline-block mr-2" :style="'height: 20px; width: 20px; border-radius: 50%; background-color: '+category.color+';'">&nbsp;</div>
                                {{category.name}}
                            </div>
                            <div>
                                <span class="small text-muted mr-2">ID: {{category.id}}</span>
                                <b-button variant="outline" class="btn-sm" @click="openEdit(category.id)"><b-icon icon="pencil-square"></b-icon></b-button>
                                <b-button variant="outline" @click="askDelete(category.id)" class="btn-sm"><b-icon icon="trash"></b-icon></b-button>
                            </div>
                        </div>

                        <div v-if="editId === category.id">
                            <hr/>
                            <validation-observer ref="observer" v-slot="{ passes }">
                                <form @submit.stop.prevent="passes(editCategory)" class="row">
                                    <div class="col-4">
                                    <validation-provider name="name" rules="min:2|required" v-slot="{ errors }">
                                        <b-form-input v-model="name"></b-form-input>
                                        <span class="validation">{{ errors[0] }}</span>
                                    </validation-provider>
                                    </div>

                                    <div class="col-4">
                                    <validation-provider name="color" rules="required|hex" v-slot="{ errors }">
                                        <b-form-input type="color" v-model="color" ></b-form-input>
                                        <span class="validation">{{ errors[0] }}</span>
                                    </validation-provider>
                                    <small class="text-muted"><a href="javascript:void(0);" @click="toggleHex = !toggleHex">Hex color</a>.</small>
                                    <div v-show="toggleHex">
                                        <validation-provider name="color" rules="required|hex" v-slot="{ errors }">
                                            <b-form-input v-model="color"></b-form-input>
                                            <span class="validation">{{ errors[0] }}</span>
                                        </validation-provider>
                                        <small class="text-muted">See this <a target="_blank" href="https://htmlcolorcodes.com/">hex color finder</a> to search for a Hex color or get the RGB-equivalent.</small>
                                    </div>
                                    </div>

                                    <div class="col-4">
                                    <a class="btn btn-outline mt-2 mr-2" @click='editId = 0'>Cancel</a>
                                    <button type="submit" class="btn primary  mt-2">Save</button>
                                    </div>
                                </form>
                            </validation-observer>
                        </div>
                    </div>
                </template>
            </div>

            <b-button class="mt-4 btn-outline" @click='isNewFormOpen = true'>
                <b-icon-plus class="text-success"></b-icon-plus>
                New category
            </b-button>

            <div v-if="isNewFormOpen">
                <hr/>
                <validation-observer ref="observer" v-slot="{ passes }">
                    <form @submit.stop.prevent="passes(createCategory)">
                        <validation-provider name="name" rules="min:2|required" v-slot="{ errors }">
                            <b-form-input v-model="name" placeholder="Name"></b-form-input>
                            <span class="validation">{{ errors[0] }}</span>
                        </validation-provider>

                        <a class="btn btn-outline mt-2 mr-2" @click='isNewFormOpen = false'>Cancel</a>
                        <button type="submit" class="btn btn-success  mt-2">Create</button>
                    </form>
                </validation-observer>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from '../mixins/NotificationPop.js'

export default {
    name: "Categories",
    mixins: [NotificationPop],
    components: {
    },

    data() {
        return {
            loading: true,
            categories: [],
            isNewFormOpen: false,
            isEditFormOpen: false,
            toggleHex: false,
            editId: 0,
            deleteId: 0,
            name: '',
            color: null,
        }
    },

    async created() {
        this.$http.get('/http_api/categories')
            .then(({data}) => {
                this.loading = false;
                this.categories = data.data
            })
            .catch(error => {
                this.loading = false;
                this.popNotification('Something went wrong on our side. Could not load. Please try again or contact ruben@productlift.dev', 'danger')
            });
    },
    methods: {
        /**
         * Create new category
         */
        createCategory: function () {
            this.$http.post('/http_api/categories',{
                name: this.name,
            })
                .then(({data}) => {
                    // add to list
                    this.categories.push({
                        id: data.data.id,
                        name: data.data.name,
                        color: data.data.color,
                    });
                    // clear form and toggle
                    this.name = ''
                    this.isNewFormOpen = false
                    this.popNotification('Created', 'success')
                })
                .catch(error => {
                    // handle authentication and validation errors here
                    console.log(error.response.data.errors)
                    this.popNotification('Could not create', 'danger')
                })
        },

        /**
         * Display edit form inside item
         * @param id category id
         */
        openEdit: function (id) {
            let index = this.categories.findIndex(category => category.id === id)

            this.editId = id
            this.name = this.categories[index].name
            this.color = this.categories[index].color
        },
        /**
         * Save edit form
         */
        editCategory: function () {
            let index = this.categories.findIndex(category => category.id === this.editId)

            this.$http.patch('/http_api/categories/' + this.editId, {
                name: this.name,
                color: this.color,
            })
                .then(({response}) => {
                    this.popNotification('Category updated successfully', 'success')
                    this.categories[index].name = this.name
                    this.categories[index].color = this.color

                    this.editId = 0 // close form
                    this.name = ''
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 422) {
                            // Validation errors
                            let errorMessages = Object.values(error.response.data.errors).flat();
                            this.popNotification(errorMessages.join(' '), 'danger')
                        } else if (error.response.status === 404) {
                            this.popNotification('Category not found. It may have been deleted.', 'danger')
                        } else if (error.response.status === 403) {
                            this.popNotification('You do not have permission to update this category.', 'danger')
                        } else {
                            this.popNotification('An unexpected error occurred. Please try again later.', 'danger')
                        }
                    } else {
                        this.popNotification('Network error. Please check your connection and try again.', 'danger')
                    }
                    console.error('Error updating category:', error)
                })
        },

        /**
         * Show modal to ask for deletion
         * @param id
         */
        askDelete: function (id) {
            this.$bvModal.show('modal-delete')
            this.deleteId = id
        },

        /**
         * After confirm, delete the category
         * @param id category id
         */
        deleteCategory: function (id) {
            // Close the modal
            this.$bvModal.hide('modal-delete')

            let index = this.categories.findIndex(category => category.id === id)

            this.$http.delete('/http_api/categories/' + id)
                .then(({response}) => {
                    this.popNotification('Category deleted successfully', 'success')
                    this.categories.splice(index, 1)
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 404) {
                            this.popNotification('Category not found. It may have already been deleted.', 'danger')
                        } else if (error.response.status === 403) {
                            this.popNotification('You do not have permission to delete this category.', 'danger')
                        } else {
                            this.popNotification('An unexpected error occurred. Please try again later.', 'danger')
                        }
                    } else {
                        this.popNotification('Network error. Please check your connection and try again.', 'danger')
                    }
                    console.error('Error deleting category:', error)
                })
        },

    }
}
</script>